<template>
  <div class="exam-paper-3">
    <img
      class="title"
      src="@/assets/images/exam-paper-title-2.png"
      alt=""
      draggable="false"
    >
    <!-- 左上角按钮 -->
    <div class="top-btn-group">
      <button
        class="return-home"
        @click="onClickReturnHome"
      />
      <button
        class="game-rule"
        @click="isShowRule = true"
      />
    </div>
    <img
      class="star"
      src="@/assets/images/pair-up-over-star.png"
      alt=""
      draggable="false"
    >
    <h2>恭喜您！</h2>
    <p class="corp-count">
      您一共答对<span class="number">{{ route.query.correntCount }}</span>道题
    </p>
    <p class="bonus-count">
      获得<span class="number">{{ route.query.bonusPoint }}</span>积分
    </p>
    <div
      class="bottom-btn-bar"
    >
      <button
        @click="router.replace({
          name: 'ExamPaper2'
        })"
      >
        重新答题
      </button>
      <button @click="onClickReturnHome">
        返回首页
      </button>
    </div>

    <GameRule
      v-show="isShowRule"
      game-title="一起来助农"
      :rich-text="store.state.gameRuleList[1].rtf"
      @close="isShowRule=false"
    />
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue"
import { useRoute, useRouter } from "vue-router"
import { useStore } from "vuex"
import { notifyQuit } from '@/api.js'
import GameRule from '@/components/GameRule.vue'

const route = useRoute()
const router = useRouter()
const store = useStore()

const isShowRule = ref(false)

const {
  windowSizeInCssForRef,
  windowSizeWhenDesignForRef,
} = useSizeAdapt(390, 752)

function onClickReturnHome() {
  if (store.state.isDirectPlayGame) {
    notifyQuit()
  } else {
    router.push({
      name: 'HomeView',
    })
  }
}

</script>

<style lang="less" scoped>
.exam-paper-3{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-image: url(@/assets/images/exam-paper-bg-2.jpg);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center bottom;
  >img.title{
    position: absolute;
    left: 50%;
    top: calc(33 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    transform: translate(-50%, 0);
    width: calc(213 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    height: calc(62 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
  }
  >.top-btn-group{
    position: absolute;
    top: calc(36 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    right: calc(12 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    display: flex;
    flex-direction: column;
    gap: calc(16 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    >button.return-home{
      background-image: url(@/assets/images/icon_home.png);
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
      width: calc(40 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
      height: calc(40 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    }
    >button.game-rule{
      background-image: url(@/assets/images/icon_rules.png);
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
      width: calc(40 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
      height: calc(40 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    }
  }
  >img.star{
    position: absolute;
    left: 50%;
    top: calc(100 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    transform: translate(-50%, 0);
    width: calc(300 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
  }
  >h2{
    position: absolute;
    left: 50%;
    top: calc(380 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    transform: translate(-35%, 0);
    font-size: calc(40 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    font-family: Source Han Sans SC, Source Han Sans SC;
    font-weight: bold;
    color: #FFFFFF;
    line-height: calc(47 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
  }
  >p.corp-count{
    position: absolute;
    left: 50%;
    top: calc(440 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    transform: translate(-50%, 0);
    font-size: calc(16 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    font-family: Source Han Sans SC, Source Han Sans SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: calc(19 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    white-space: pre;
    >span.number{
      font-size: calc(24 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
      font-family: heiti;
      font-weight: bold;
      color: #EFB622;
      line-height: calc(28 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
      margin-left: 0.2em;
      margin-right: 0.2em;
    }
  }
  >p.bonus-count{
    position: absolute;
    left: 50%;
    top: calc(480 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    transform: translate(-50%, 0);
    font-size: calc(16 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    font-family: Source Han Sans SC, Source Han Sans SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: calc(19 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    white-space: pre;
    >span.number{
      font-size: calc(24 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
      font-family: heiti;
      font-weight: bold;
      color: #EFB622;
      line-height: calc(28 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
      margin-left: 0.2em;
      margin-right: 0.2em;
    }
  }
  >.bottom-btn-bar{
    position: absolute;
    left: 50%;
    bottom: calc(73 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    transform: translate(-50%, 0);
    width: calc(322 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    display: flex;
    justify-content: space-between;
    >button{
      width: calc(149 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
      height: calc(70 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
      background-image: url(@/assets/images/exam-paper-btn-short-bg.png);
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
      font-size: calc(24 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
      font-family: Source Han Sans SC, Source Han Sans SC;
      font-weight: 800;
      color: #FFFFFF;
      line-height: calc(32 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
      // -webkit-text-stroke: calc(1 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef')) #4E3933;
      padding-bottom: calc(5 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    }
  }
}
</style>